import { ReactNode } from "react";

// Tela de aviso do betracking (código não encontrado, código inválido, falha
// na consulta, página que não existe, erro inesperado): um cartão só, no
// mesmo visual do rastreio, com o que aconteceu, o que fazer e a saída.
export default function Aviso({
  icone,
  titulo,
  texto,
  children,
  dicas,
}: {
  icone: ReactNode;
  titulo: string;
  texto: ReactNode;
  children?: ReactNode;
  dicas?: string[];
}) {
  return (
    <section className="mx-auto flex max-w-2xl flex-col items-center rounded-3xl bg-white px-5 py-10 text-center shadow-[0_1px_2px_rgba(63,32,33,0.06),0_8px_24px_rgba(63,32,33,0.06)] ring-1 ring-[#EFE6DD] sm:px-12 sm:py-14">
      <div className="flex size-16 items-center justify-center rounded-full bg-[#FFF1E6] text-[#DC4405]">{icone}</div>
      <h1 className="mt-5 text-2xl font-bold leading-tight text-[#3F2021] sm:text-3xl">{titulo}</h1>
      <p className="mt-3 max-w-md text-[15px] leading-relaxed text-[#6b5556] sm:text-base">{texto}</p>
      {children && <div className="mt-7 flex w-full flex-col items-center gap-3">{children}</div>}
      {dicas && dicas.length > 0 && (
        <ul className="mt-8 w-full max-w-md space-y-2 border-t border-[#F1E8DF] pt-6 text-left text-sm text-[#6b5556]">
          {dicas.map((d) => (
            <li key={d} className="flex gap-2.5">
              <span className="mt-[7px] size-1.5 shrink-0 rounded-full bg-[#DC4405]" />
              {d}
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
